const { $ } = window
const $body = $(document.body)

export default {
	init() {
		generatePageNav()
	},
	finalize() {
		// JavaScript to be fired on the home page, after the init JS
	},
}


function generatePageNav() {
   const nav = document.querySelector('.legal-page-nav ul')
   const setions = document.querySelectorAll( '.main-content-wrap h2' );
   setions.forEach((h2) => {
      let li = document.createElement('li')
      let a = document.createElement('a')
      a.innerText = h2.innerText
      const id = h2.innerText.toLowerCase().replace(/\s+/g, '-')
      h2.id = id
      a.id = id + '-anchor'
      a.href = `#${id}`
      a.classList.add('legal-nav-link')
      li.appendChild(a)
      nav.appendChild(li)
   })
   let enableScrolling = false;
   setTimeout(() => { enableScrolling = true;}, 1000)
   let activeId = location.hash.substr( 1 );
   if ( ! activeId ) {
      activeId = setions[ 0 ].id;
   }
   let inPageNavAnchors = Array.from(document.querySelectorAll('.tos-nav-link'));
   let activeAnchor = document.querySelector( `a[id="${ activeId }-anchor"]` );
   activeAnchor.classList.add( 'active' );
   document.onscroll = () => {
      if ( enableScrolling ) {
         for ( const h2 of setions ) {
            if ( 0 < h2.getBoundingClientRect().bottom ) {
               if ( ! activeId.includes( h2.id ) ) {
                  inPageNavAnchors.map( ( item ) => {
                     item.classList.remove( 'active' ) 
                  });
                  activeId = h2.id;
                  activeAnchor = document.querySelector(
                     `a[id="${ activeId }-anchor"]`
                  );
                  activeAnchor.classList.add( 'active' );
               }
               break;
            }
         }
      }
   };

   let t
   $(inPageNavAnchors).click((e) => {
      enableScrolling = false
      $(inPageNavAnchors).removeClass('active')
      e.target.classList.add('active')
      let t = setTimeout( () => {
         enableScrolling = true;
      }, 1000 );
   })

}
